var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"select",class:{select_compact: _vm.compact},attrs:{"options":_vm.options,"reduce":(item) => item.value,"value":_vm.value,"clearable":_vm.clearable ?? true,"searchable":false},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }